import { useInstitutionsStore } from '@/stores/institutions';
import { useOrganizationsStore } from '@/stores/organizations';
import { useSocketStore } from '@/stores/socket';
import { ESocketListenMessageType } from '@/types';
import { useEffect } from 'react';

export const useProvisioningGateway = () => {
  const { listenMessage, isConnected, stopListenMessage } = useSocketStore(
    (state) => ({
      listenMessage: state.listenMessage,
      stopListenMessage: state.stopListenMessage,
      isConnected: state.isConnected,
      sendMessage: state.sendMessage,
    }),
  );

  const updateProvisioningOrganization = useOrganizationsStore(
    (state) => state.updateProvisioning,
  );
  const updateProvisioningInstitution = useInstitutionsStore(
    (state) => state.updateProvisioning,
  );

  useEffect(() => {
    if (!isConnected) return;
    listenMessage({
      type: ESocketListenMessageType.PROVISIONING,
      callback: ({ provisioning }) => {
        if (provisioning.institutionId) {
          updateProvisioningInstitution(provisioning);
          return;
        }
        updateProvisioningOrganization(provisioning);
      },
    });
    return () => {
      stopListenMessage(ESocketListenMessageType.PROVISIONING);
    };
  }, [
    isConnected,
    listenMessage,
    stopListenMessage,
    updateProvisioningInstitution,
    updateProvisioningOrganization,
  ]);
};
